import { render, staticRenderFns } from "./salle-attente.html?vue&type=template&id=4a562028&scoped=true&external"
import script from "./salle-attente.js?vue&type=script&lang=js&external"
export * from "./salle-attente.js?vue&type=script&lang=js&external"
import style0 from "./salle-attente.scss?vue&type=style&index=0&id=4a562028&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a562028",
  null
  
)

export default component.exports